import { render, staticRenderFns } from "./BiographySection.vue?vue&type=template&id=76650191&scoped=true&"
import script from "./BiographySection.vue?vue&type=script&lang=js&"
export * from "./BiographySection.vue?vue&type=script&lang=js&"
import style0 from "./BiographySection.vue?vue&type=style&index=0&id=76650191&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76650191",
  null
  
)

export default component.exports